// ÇİÇEKLİ BİTKİLER PART 1 - bitkiVeritabani3.js
// Cryptocoryne + Echinodorus başlangıç (30 bitki)

export const cicekliBitkilerPart1 = [
  // ==================== CRYPTOCORYNE (Low-Mid Tech) ====================
  {
    id: 'cryptocoryne-wendtii-green',
    isim: 'Yeşil Cryptocoryne',
    latince: 'Cryptocoryne wendtii Green',
    resim: '/images/bitkiler/cryptocoryne-wendtii-green.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Sri Lanka',
    uzunluk: '10-20 cm',
    genislik: '10-15 cm',
    sicaklik: '22-28°C',
    ph: '6.0-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Kolay',
    konum: 'Ön - Orta plan',
    aciklama: 'En popüler ve dayanıklı Cryptocoryne türü. Yeşil dalgalı yapraklar.'
  },
  {
    id: 'cryptocoryne-wendtii-brown',
    isim: 'Kahverengi Cryptocoryne',
    latince: 'Cryptocoryne wendtii Brown',
    resim: '/images/bitkiler/cryptocoryne-wendtii-brown.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Sri Lanka',
    uzunluk: '10-25 cm',
    genislik: '10-15 cm',
    sicaklik: '22-28°C',
    ph: '6.0-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Kolay',
    konum: 'Ön - Orta plan',
    aciklama: 'Kahverengi-bronz tonlarında yapraklar. Çok dayanıklı.'
  },
  {
    id: 'cryptocoryne-wendtii-tropica',
    isim: 'Tropica Cryptocoryne',
    latince: 'Cryptocoryne wendtii Tropica',
    resim: '/images/bitkiler/cryptocoryne-wendtii-tropica.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Sri Lanka (Kültür formu)',
    uzunluk: '10-15 cm',
    genislik: '10-15 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Kolay',
    konum: 'Ön plan',
    aciklama: 'Kompakt büyüyen, koyu kahverengi yapraklı.'
  },
  {
    id: 'cryptocoryne-wendtii-mi-oya',
    isim: 'Mi Oya Cryptocoryne',
    latince: 'Cryptocoryne wendtii Mi Oya',
    resim: '/images/bitkiler/cryptocoryne-wendtii-mi-oya.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Sri Lanka',
    uzunluk: '15-25 cm',
    genislik: '15-20 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Kolay',
    konum: 'Orta plan',
    aciklama: 'Kırmızımsı-kahverengi geniş yapraklı varyant.'
  },
  {
    id: 'cryptocoryne-beckettii',
    isim: 'Beckett Cryptocoryne',
    latince: 'Cryptocoryne beckettii',
    resim: '/images/bitkiler/cryptocoryne-beckettii.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Sri Lanka',
    uzunluk: '10-20 cm',
    genislik: '10-15 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Kolay',
    konum: 'Ön - Orta plan',
    aciklama: 'Yeşil-kahverengi yapraklı, kompakt büyüyen tür.'
  },
  {
    id: 'cryptocoryne-beckettii-petchii',
    isim: 'Petchii Cryptocoryne',
    latince: 'Cryptocoryne beckettii Petchii',
    resim: '/images/bitkiler/cryptocoryne-beckettii-petchii.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Sri Lanka',
    uzunluk: '10-15 cm',
    genislik: '8-12 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Kolay',
    konum: 'Ön plan',
    aciklama: 'Küçük boyutlu, pembe-kahverengi yapraklı.'
  },
  {
    id: 'cryptocoryne-undulata',
    isim: 'Dalgalı Cryptocoryne',
    latince: 'Cryptocoryne undulata',
    resim: '/images/bitkiler/cryptocoryne-undulata.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Sri Lanka',
    uzunluk: '15-25 cm',
    genislik: '10-15 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Kolay',
    konum: 'Orta plan',
    aciklama: 'Dalgalı kenarlı yeşil-kahverengi yapraklar.'
  },
  {
    id: 'cryptocoryne-undulata-broad-leaves',
    isim: 'Geniş Yapraklı Cryptocoryne',
    latince: 'Cryptocoryne undulata Broad Leaves',
    resim: '/images/bitkiler/cryptocoryne-undulata-broad-leaves.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Sri Lanka',
    uzunluk: '15-30 cm',
    genislik: '15-20 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Kolay',
    konum: 'Orta plan',
    aciklama: 'Geniş dalgalı yapraklı varyant.'
  },
  {
    id: 'cryptocoryne-walkeri-lutea',
    isim: 'Sarı Cryptocoryne',
    latince: 'Cryptocoryne walkeri Lutea',
    resim: '/images/bitkiler/cryptocoryne-walkeri-lutea.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Sri Lanka',
    uzunluk: '10-20 cm',
    genislik: '10-15 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Kolay',
    konum: 'Ön - Orta plan',
    aciklama: 'Sarımsı-yeşil yaprakları ile farklı bir tür.'
  },
  {
    id: 'cryptocoryne-x-willisii',
    isim: 'Willis Cryptocoryne',
    latince: 'Cryptocoryne x willisii',
    resim: '/images/bitkiler/cryptocoryne-x-willisii.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Sri Lanka',
    uzunluk: '7-15 cm',
    genislik: '8-12 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Kolay',
    konum: 'Ön plan',
    aciklama: 'Küçük boyutlu, ön plan için ideal Cryptocoryne.'
  },
  {
    id: 'cryptocoryne-parva',
    isim: 'Cüce Cryptocoryne',
    latince: 'Cryptocoryne parva',
    resim: '/images/bitkiler/cryptocoryne-parva.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Sri Lanka',
    uzunluk: '3-6 cm',
    genislik: '3-5 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Çok yavaş',
    bakimZorlugu: 'Orta',
    konum: 'Ön plan',
    aciklama: 'En küçük Cryptocoryne türü. Zemin kaplama için ideal ama çok yavaş.'
  },
  {
    id: 'cryptocoryne-pontederiifolia',
    isim: 'Pontederia Cryptocoryne',
    latince: 'Cryptocoryne pontederiifolia',
    resim: '/images/bitkiler/cryptocoryne-pontederiifolia.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Sumatra',
    uzunluk: '15-25 cm',
    genislik: '15-20 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Yavaş - Orta',
    bakimZorlugu: 'Kolay',
    konum: 'Orta plan',
    aciklama: 'Kalp şeklinde yaprakları ile farklı bir tür.'
  },
  {
    id: 'cryptocoryne-affinis',
    isim: 'Affinis Cryptocoryne',
    latince: 'Cryptocoryne affinis',
    resim: '/images/bitkiler/cryptocoryne-affinis.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Malezya',
    uzunluk: '15-30 cm',
    genislik: '15-25 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Yavaş - Orta',
    bakimZorlugu: 'Kolay',
    konum: 'Orta plan',
    aciklama: 'Koyu yeşil üst, kırmızı alt yüzlü yapraklar.'
  },
  {
    id: 'cryptocoryne-albida',
    isim: 'Albida Cryptocoryne',
    latince: 'Cryptocoryne albida',
    resim: '/images/bitkiler/cryptocoryne-albida.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Tayland, Myanmar',
    uzunluk: '10-20 cm',
    genislik: '8-15 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Orta',
    konum: 'Ön - Orta plan',
    aciklama: 'Dar uzun yapraklı, zarif görünümlü tür.'
  },
  {
    id: 'cryptocoryne-alba',
    isim: 'Alba Cryptocoryne',
    latince: 'Cryptocoryne alba',
    resim: '/images/bitkiler/cryptocoryne-alba.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Sri Lanka',
    uzunluk: '15-25 cm',
    genislik: '10-15 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Orta',
    konum: 'Orta plan',
    aciklama: 'Uzun dar yapraklı nadir tür.'
  },
  {
    id: 'cryptocoryne-crispatula-balansae',
    isim: 'Balansae Cryptocoryne',
    latince: 'Cryptocoryne crispatula var. Balansae',
    resim: '/images/bitkiler/cryptocoryne-crispatula-balansae.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Tayland, Vietnam',
    uzunluk: '30-60 cm',
    genislik: '15-25 cm',
    sicaklik: '20-28°C',
    ph: '6.5-8.0',
    sertlik: 'Orta - Sert',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Kolay',
    konum: 'Arka plan',
    aciklama: 'Uzun kabartmalı yaprakları ile etkileyici. Sert suyu tolere eder.'
  },
  {
    id: 'cryptocoryne-cordata-blassii',
    isim: 'Blassii Cryptocoryne',
    latince: 'Cryptocoryne cordata var. blassii',
    resim: '/images/bitkiler/cryptocoryne-cordata-blassii.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Tayland',
    uzunluk: '20-40 cm',
    genislik: '15-25 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Orta',
    konum: 'Orta - Arka plan',
    aciklama: 'Koyu yeşil üst, mor alt yüzlü büyük yapraklar.'
  },

  // ==================== ECHINODORUS (Amazon Kılıçları) ====================
  {
    id: 'echinodorus-bleheri',
    isim: 'Amazon Kılıcı',
    latince: 'Echinodorus bleheri',
    resim: '/images/bitkiler/echinodorus-bleheri.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Güney Amerika',
    uzunluk: '30-60 cm',
    genislik: '25-40 cm',
    sicaklik: '20-28°C',
    ph: '6.0-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Orta - Hızlı',
    bakimZorlugu: 'Kolay',
    konum: 'Arka plan / Odak noktası',
    aciklama: 'En popüler akvaryum bitkilerinden biri. Büyük yeşil yapraklar.'
  },
  {
    id: 'echinodorus-major',
    isim: 'Dev Amazon Kılıcı',
    latince: 'Echinodorus major',
    resim: '/images/bitkiler/echinodorus-major.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Brezilya',
    uzunluk: '40-80 cm',
    genislik: '30-50 cm',
    sicaklik: '22-28°C',
    ph: '6.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Kolay - Orta',
    konum: 'Arka plan / Odak noktası',
    aciklama: 'Çok büyük boyuta ulaşan dalgalı yapraklı tür.'
  },
  {
    id: 'echinodorus-uruguayensis',
    isim: 'Uruguay Amazon',
    latince: 'Echinodorus uruguayensis',
    resim: '/images/bitkiler/echinodorus-uruguayensis.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Güney Amerika',
    uzunluk: '30-50 cm',
    genislik: '20-35 cm',
    sicaklik: '18-26°C',
    ph: '6.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Kolay',
    konum: 'Arka plan',
    aciklama: 'Dar uzun yapraklı, serin suyu tolere eden tür.'
  },
  {
    id: 'echinodorus-cordifolius',
    isim: 'Kalp Yapraklı Amazon',
    latince: 'Echinodorus cordifolius',
    resim: '/images/bitkiler/echinodorus-cordifolius.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Kuzey ve Orta Amerika',
    uzunluk: '30-60 cm',
    genislik: '25-40 cm',
    sicaklik: '20-28°C',
    ph: '6.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Orta - Hızlı',
    bakimZorlugu: 'Kolay',
    konum: 'Arka plan',
    aciklama: 'Kalp şeklinde yaprakları ile tanınır.'
  },
  {
    id: 'echinodorus-cordifolius-fluitans',
    isim: 'Yüzen Amazon',
    latince: 'Echinodorus cordifolius ssp. fluitans',
    resim: '/images/bitkiler/echinodorus-cordifolius-fluitans.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Meksika',
    uzunluk: '20-40 cm',
    genislik: '20-30 cm',
    sicaklik: '22-28°C',
    ph: '6.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Kolay',
    konum: 'Orta - Arka plan',
    aciklama: 'Kompakt büyüyen kalp yapraklı varyant.'
  },
  {
    id: 'echinodorus-cordifolius-marble-queen',
    isim: 'Mermer Kraliçe',
    latince: 'Echinodorus cordifolius Tropica Marble Queen',
    resim: '/images/bitkiler/echinodorus-cordifolius-marble-queen.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Kültür formu',
    uzunluk: '20-40 cm',
    genislik: '20-30 cm',
    sicaklik: '22-28°C',
    ph: '6.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Yavaş - Orta',
    bakimZorlugu: 'Orta',
    konum: 'Orta plan',
    aciklama: 'Beyaz-yeşil mermer desenli yapraklar.'
  },
  {
    id: 'echinodorus-osiris',
    isim: 'Osiris Kılıcı',
    latince: 'Echinodorus osiris',
    resim: '/images/bitkiler/echinodorus-osiris.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Güney Brezilya',
    uzunluk: '30-50 cm',
    genislik: '25-40 cm',
    sicaklik: '18-26°C',
    ph: '6.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Kolay',
    konum: 'Arka plan',
    aciklama: 'Genç yapraklar kırmızımsı, olgunlaşınca yeşil.'
  },
  {
    id: 'echinodorus-ozelot',
    isim: 'Ozelot Kılıcı',
    latince: 'Echinodorus ozelot',
    resim: '/images/bitkiler/echinodorus-ozelot.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Kültür formu',
    uzunluk: '25-40 cm',
    genislik: '25-35 cm',
    sicaklik: '20-28°C',
    ph: '6.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Kolay',
    konum: 'Orta - Arka plan',
    aciklama: 'Koyu kırmızı benekli yeşil yapraklar. Çok dekoratif.'
  },
  {
    id: 'echinodorus-ozelot-green',
    isim: 'Yeşil Ozelot',
    latince: 'Echinodorus Ozelot Green',
    resim: '/images/bitkiler/echinodorus-ozelot-green.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Kültür formu',
    uzunluk: '25-40 cm',
    genislik: '25-35 cm',
    sicaklik: '20-28°C',
    ph: '6.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Kolay',
    konum: 'Orta - Arka plan',
    aciklama: 'Yeşil yapraklarda koyu yeşil benekler.'
  },
  {
    id: 'echinodorus-rose',
    isim: 'Gül Amazon',
    latince: 'Echinodorus Rose',
    resim: '/images/bitkiler/echinodorus-rose.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Kültür formu',
    uzunluk: '20-35 cm',
    genislik: '20-30 cm',
    sicaklik: '22-28°C',
    ph: '6.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Yavaş - Orta',
    bakimZorlugu: 'Orta',
    konum: 'Orta plan',
    aciklama: 'Pembe-kırmızı genç yaprakları ile çok dekoratif.'
  },
  {
    id: 'echinodorus-rubin',
    isim: 'Rubin Kılıcı',
    latince: 'Echinodorus rubin',
    resim: '/images/bitkiler/echinodorus-rubin.jpg',
    kategori: 'Çiçekli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Kültür formu',
    uzunluk: '30-50 cm',
    genislik: '25-40 cm',
    sicaklik: '22-28°C',
    ph: '6.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Orta',
    konum: 'Arka plan',
    aciklama: 'Koyu kırmızı-bordo yapraklı büyük bitki.'
  }
];

export default cicekliBitkilerPart1;